module.exports = __webpack_public_path__ + "img/globish-logo.270ee4b8.png";